import { FaShoppingCart } from "react-icons/fa";
import { Link } from "react-router-dom";
import PendingOrderBadge from "./PendingOrderBadge";

export default function TotalPendingOrder() {
  return (
    <Link to="/order-list" className="relative flex h-10 w-10 items-center justify-center rounded-xl border border-slate-200 bg-slate-50 text-slate-600 transition hover:border-blue-300 hover:text-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-600 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200" title="سفارش‌های در انتظار">
      <div className="flex items-center justify-center">
        <FaShoppingCart size={18} />
        <PendingOrderBadge className="absolute -bottom-1 -left-1 h-5 min-w-5 rounded-full border-2 border-white bg-blue-600 px-0.5 text-[10px] font-semibold text-white dark:border-slate-900" />
      </div>
    </Link>
  );
}
